// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1nLrx","insightsList":"newBusinessInsightsMenu_insightsList__3nmbA","active":"newBusinessInsightsMenu_active__1MnGH"};